import { render } from "./pharmacyslider.vue?vue&type=template&id=3ea1ad2e"
import script from "./pharmacyslider.vue?vue&type=script&lang=js"
export * from "./pharmacyslider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__